// the Jumbo themes make this one a little difficult to remove (you'd have to
// override _each_ of the Layouts), so instead we noop the contents to render
// null, and we'll copy-pasta where we want it

export default () => null;
